import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import HomePage from "./pages/HomePage";
import ResponsePage from "./pages/ResponsePage";

import "./fonts/AvenirBlack.ttf";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={HomePage}></Route>
        <Route path="/invite" component={ResponsePage}></Route>
      </Switch>
    </Router>
  );
}

export default App;
